module.exports = __webpack_public_path__ + "img/Seismic Vulnerability Assessment.66404c61.jpg";